import { Navigate } from 'react-router';

import useIsParent from 'common/hook/useIsParent';
import useIsGuest from 'common/hook/useIsGuest';
import { ROUTES_PATH } from 'layout/constants';

/**
 * Chặn phụ huynh/khách gõ URL thẳng vào route bị hạn chế (chi tiết NCC / QR NCC TPAT) → điều
 * hướng về Dashboard (docx §4/§6: "403 Forbidden ... tự động điều hướng về Dashboard"; docx
 * 07.08 [76][85]: khách không được xem chi tiết NCC / QR NCC TPAT).
 * Nhận diện phụ huynh qua chức vụ KH-PHOTHONG (useIsParent); khách qua claim token (useIsGuest).
 */
const ParentBlockedRoute = ({ children }: { children: JSX.Element }): JSX.Element => {
  const isParent = useIsParent();
  const isGuest = useIsGuest();
  // Khách cũng không được vào QR NCC TPAT / chi tiết NCC (docx 07.08 [76][85]).
  if (isParent || isGuest) {
    return <Navigate to={`/${ROUTES_PATH.portal.index}/${ROUTES_PATH.dashboard.index}`} replace />;
  }
  return children;
};

export default ParentBlockedRoute;
